/**
 * Util function to convert the PricePoint description to meet the design standard.
 *
 * @param value description of kilometrage (e.g. 10001 - 15000)
 * @returns string separated by thousand and without the extra '1' (e.g. 10.000 - 15.000)
 */
export const formatKilometrageDescription = (value: string): string => {
	const split = value.split(' ');
	const fromKm = Number(split[0]);
	const toKm = split.length > 2 ? Number(split[2]) : undefined;

	if (toKm === undefined) {
		return `tot ${fromKm.toLocaleString('nl-NL')}`;
	}

	return `${
		fromKm > 0 && fromKm % 10 === 1 ? `${(fromKm - 1).toLocaleString('nl-NL')} -` : 'tot'
	} ${toKm.toLocaleString('nl-NL')}`;
};
